import { memo, PropsWithChildren, useCallback, useContext } from 'react';
import { Link, To } from 'react-router-dom';
import { Button } from 'src/modules/common/components/Button/Button';
import { ArrowLeftIcon } from 'src/modules/common/icons/ArrowLeftIcon';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { ConfigContext } from 'src/configContext.ts';

type Props = PropsWithChildren<{
    to: To;
    state?: Record<string, unknown>;
    type: 'forward' | 'back';
    disabled?: boolean;
    fullWidth?: boolean;
    eventData?: Record<string, unknown>;
}>

export const NavigationButton = memo(({ to, state, type, disabled, fullWidth, eventData, children }: Props) => {
    const { gaPush } = useContext(ConfigContext);
    const onClick = useCallback(() => {
        if (eventData && disabled !== true) {
            gaPush(eventData);
        }
    }, [eventData, gaPush, disabled]);
    return (
        <Button
            onClick={onClick}
            as={Link}
            to={to}
            state={state}
            kind={type === 'back' ? 'ghost' : 'primary'}
            reversed={type === 'back'}
            disabled={disabled}
            fullWidth={fullWidth}
            icon={(
                <div className="vss-navigation__button-icon">
                    {type === 'back' ? (<ArrowLeftIcon/>) : (<ArrowRightIcon/>)}
                </div>
            )}
        >
            {children}
        </Button>
    );
});
